export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20interior%20with%20warm%20golden%20stage%20lighting%20and%20velvet%20curtains%2C%20elegant%20movie%20theater%20atmosphere%20with%20soft%20spotlight%20effects%2C%20luxurious%20cinema%20environment%20with%20rich%20deep%20red%20and%20gold%20accents%2C%20professional%20film%20industry%20setting%20with%20dramatic%20shadows%20and%20warm%20ambient%20glow%2C%20empty%20theater%20seats%20facing%20a%20brightly%20lit%20screen&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="榴莲视频影视平台背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14 max-w-6xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-sm font-medium text-primary-300 whitespace-nowrap">海量影视 · 高清畅享</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-white leading-tight mb-4">
              榴莲视频 - 高清影视聚合观看平台
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              苹果视频、91视频网站、豆花视频、菠萝视频等热门站点一站式聚合
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              榴莲视频整合苹果视频、91视频网站、豆花视频、菠萝视频、红杏视频、青青草视频等多家优质影视站点资源，提供每日更新的高清影视观看体验。无论是热门大片、经典剧集还是海外剧场，都能在这里一站畅享，高清画质配合流畅的视频播放技术，让每一次观影都成为享受。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-white whitespace-nowrap">2000+</span>
                <span className="text-sm text-white/60 whitespace-nowrap">每日更新片源</span>
              </div>
              <div className="w-px h-8 bg-white/15 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-white whitespace-nowrap">8+</span>
                <span className="text-sm text-white/60 whitespace-nowrap">站点资源聚合</span>
              </div>
              <div className="w-px h-8 bg-white/15 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-accent-400 whitespace-nowrap">4K</span>
                <span className="text-sm text-white/60 whitespace-nowrap">超清画质支持</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-lg border border-white/30 hover:border-white/50 text-white font-semibold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap hover:bg-white/5"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20film%20reel%20and%20movie%20clapperboard%20artistic%20composition%20on%20dark%20theater%20background%2C%20warm%20golden%20spotlight%20with%20dramatic%20shadows%2C%20luxurious%20velvet%20texture%20and%20film%20strip%20elements%2C%20professional%20movie%20industry%20photography%20with%20rich%20amber%20and%20crimson%20tones%2C%20elegant%20entertainment%20aesthetic&width=600&height=500&seq=hero-visual-01&orientation=landscape"
                alt="榴莲视频高清影视聚合平台主视觉"
                className="relative w-full h-auto rounded-xl object-cover shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}